<mat-toolbar color="grey">
  <mat-toolbar-row>
    <div class="toolbar-line" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
      <div class="mat-avatar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-file-alt">
        </mat-icon>
        <div class="title" fxLayout="column" fxLayoutAlign="center start">
          <h3 matLine> {{data.doc.documentationTypeName}} </h3>
          <h5 matLine>{{'common.documentDateLbl' | transloco}}: {{data.doc.documentDate | date :'dd/MM/yyyy' }}
            {{headerCreatedByMessageInfo}}</h5>
        </div>
      </div>
      <button mat-icon-button (click)="cancel()" title="{{'common.closeBtn' | transloco}}">
        <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
      </button>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<div class="add-menu-form-body w-table" fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="center stretch "
  style="padding:16px">
  <mat-list>
    <mat-list-item class="metadata-state-item" lines="1">
      <app-file-document-state [item]="data.doc" [showSmallChips]="false"></app-file-document-state>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item lines="2">
      <mat-icon matListItemIcon fontSet="fas" fontIcon="fa-file-alt"></mat-icon>
      <span matListItemTitle class="meta-label">{{'common.documentIdLbl' | transloco}}</span>
      <span matListItemLine class="meta-value">{{data.doc.id}}</span>
      <button matListItemMeta mat-icon-button ngxClipboard [cbContent]="('metadata.moreDataComponent.Id' | transloco) + ': ' + data.doc.id">
        <mat-icon class="fa-lg" fontSet="fas" fontIcon="fa-link"></mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item lines="2">
      <mat-icon matListItemIcon fontSet="fas" fontIcon="fa-id-badge"></mat-icon>
      <span matListItemTitle class="meta-label">{{'common.employeeIdLbl' | transloco}}</span>
      <span matListItemLine class="meta-value">{{data.doc.EmployeeCompleteName}}</span>
      <button matListItemMeta mat-icon-button ngxClipboard [cbContent]="('metadata.moreDataComponent.Legajo' | transloco) + ': ' + data.doc.EmployeeCompleteName">
        <mat-icon class="fa-lg" fontSet="fas" fontIcon="fa-link"></mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item lines="2">
      <mat-icon matListItemIcon fontSet="fa" fontIcon="fa-book-user"></mat-icon>
      <span matListItemTitle class="meta-label">{{'common.fileNumberLbl' | transloco}}</span>
      <span matListItemLine class="meta-value">{{data.doc.nroLegajo}}</span>
      <button matListItemMeta mat-icon-button ngxClipboard [cbContent]="('metadata.moreDataComponent.Legajo Nro' | transloco) + ': ' + data.doc.nroLegajo">
        <mat-icon class="fa-lg" fontSet="fas" fontIcon="fa-link"></mat-icon>
      </button>
    </mat-list-item>
    <mat-list-item lines="2">
      <mat-icon matListItemIcon fontSet="fa" fontIcon="fa-passport"></mat-icon>
      <span matListItemTitle class="meta-label">{{'common.taxIdLbl' | transloco}}</span>
      <span matListItemLine class="meta-value">{{data.doc.employeeLegalId}}</span>
      <button matListItemMeta mat-icon-button ngxClipboard [cbContent]="('metadata.moreDataComponent.Identificador Fiscal' | transloco) + ': ' + data.doc.employeeLegalId">
        <mat-icon class="fa-lg" fontSet="fas" fontIcon="fa-link"></mat-icon>
      </button>
    </mat-list-item>
    <ng-container *ngIf="otrosMetadatos">
      <mat-divider></mat-divider>
      <mat-list-item lines="2">
        <span matListItemTitle class="meta-label">{{'common.others' | transloco}}</span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item lines="2" *ngFor="let item of data.doc.metadataAditional">
        <mat-icon matListItemIcon fontSet="fa" [fontIcon]="metadataIcon(item)"></mat-icon>
        <span matListItemTitle class="meta-label">{{item.metadataLabel}}</span>
        <span matListItemLine class="meta-value" *ngIf="item.metadataType ==='date'">{{item.metadataValue | date :'dd/MM/yyyy'}}</span>
        <span matListItemLine class="meta-value" *ngIf="item.metadataType ==='period'">{{item.formatMetadata() | date :'MMMM yyyy'}}</span>
        <span matListItemLine class="meta-value" *ngIf="item.metadataType !=='date' && item.metadataType !== 'period'">{{item.formatMetadata()}}</span>
      </mat-list-item>
    </ng-container>
  </mat-list>
</div>
